export default {
  apiKey: 'AIzaSyDymeFZYs2beN-K70mM4hD77bmLyxQCRLo',
  authDomain: 'quickytools-dev.firebaseapp.com',
  databaseURL: 'https://quickytools-dev.firebaseio.com',
  projectId: 'quickytools-dev',
  storageBucket: 'quickytools-dev.appspot.com',
  messagingSenderId: '343532809100',
  appId: '1:343532809100:web:7558f20b7e55733b',
  measurementId: 'G-SV65G0T7NT'
}
